export const FLOAT_REGEX = /^\d*\.?\d*$/;
// const emailValidation = /^[\w-.+]+@[a-zA-Z-]+(?:\.[a-zA-Z]{2,})+$/;
const emailValidation = /^[\w-.+]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z]{2,})+$/;

const alphabeticOnly = /^[A-Za-zÀ-ž-' ]+$/;

const numbersOnly = /^[0-9]*$/;

const usernameValidation = /^[\w_](?=.*[a-zA-Z])(?!.*?\.{2})[\w.]{1,30}[\w]$/;

const utfCharsValidation = /[\u0300-\u036f '-]+/g;

export {
  emailValidation,
  alphabeticOnly,
  numbersOnly,
  usernameValidation,
  utfCharsValidation,
};
